// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"673":"31c84d27","767":"62b5075b"}[chunkId] + ".chunk.js");